export default "__VITE_ASSET__GhBHksps__"